module.exports = __webpack_public_path__ + "img/img2.d15b11f7.svg";